export const staffEnvironment = {
  production: false,
  development: true,
  apiUrl: 'https://dev.api.petszelconnectbackend.petszel.com/',
  bgNavColor: '#FFC7A7'
};
